import axios from "axios";
import config from "../../../config";

/**
 * POST api/v1/customer-portal/categories
 * Returns active categories for the logged-in client's salon (is_active=1, salon_id from user).
 */
export function fetchCustomerPortalCategories(token) {
  return axios.post(`${config.API_URL}customer-portal/categories`, {}, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
}

/**
 * POST api/v1/customer-portal/category-services
 * Body: { category_id: number }
 * Active bookable services + active staff (online booking), with tier-based price.
 */
export function fetchCustomerPortalCategoryServices(token, categoryId) {
  return axios.post(
    `${config.API_URL}customer-portal/category-services`,
    { category_id: categoryId },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
}

/**
 * POST api/v1/customer-portal/availability/month
 * Body: { year_month, segments: [{ staff_id, duration_minutes }], padding_minutes?, exclude_appointment_id? }
 */
export function fetchCustomerPortalAvailabilityMonth(token, body) {
  return axios.post(`${config.API_URL}customer-portal/availability/month`, body, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
}

/**
 * POST api/v1/customer-portal/availability/day-slots
 * Body: { date: YYYY-MM-DD, segments, padding_minutes?, exclude_appointment_id? }
 */
export function fetchCustomerPortalAvailabilityDaySlots(token, body) {
  return axios.post(`${config.API_URL}customer-portal/availability/day-slots`, body, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
}

/**
 * POST api/v1/customer-portal/availability/validate-start-time
 * Body: { start_datetime, segments, padding_minutes?, exclude_appointment_id? }
 */
export function validateCustomerPortalStartTime(token, body) {
  return axios.post(`${config.API_URL}customer-portal/availability/validate-start-time`, body, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
}
